import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// De taal die de bezoeker in de app zag (landingspagina) of anders die van de browser. Gaat mee
// naar het CRM voor de eerste mails; de echte keuze volgt in de onboarding.
export function browserTaal() {
    try {
        const bewaard = localStorage.getItem('language');
        if (bewaard === 'nl' || bewaard === 'en') return bewaard;
    } catch (error) { /* geen opslag beschikbaar */ }
    return (navigator.language || '').startsWith('nl') ? 'nl' : 'en';
}

// Vraagt het proefabonnement en het marketingcontact aan (Cloud Function ensureUserAccount). Dat kan
// pas na een bevestigd e-mailadres: de claim "email_verified" zit pas in een ververst token.
// Levert true als er niets meer te doen is (gelukt, of het account heeft al een abonnement) en false
// als het adres nog niet bevestigd was of de aanroep mislukte: dan moet het later opnieuw.
export async function vraagAccountSetupAan(gebruiker) {
    try {
        await gebruiker.getIdToken(true);
        const resultaat = await httpsCallable(functions, 'ensureUserAccount')({ language: browserTaal() });
        return resultaat?.data?.reason !== 'email-not-verified';
    } catch (error) {
        console.error('Kon account niet initialiseren:', error);
        return false;
    }
}
